export default "__VITE_ASSET__j463CTUf__"